import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sidenav-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "font-weight-bold gorda-sidenav__brand-name" }
const _hoisted_4 = ["title", "aria-label"]
const _hoisted_5 = {
  class: "collapse navbar-collapse w-auto",
  id: "sidenav-collapse-main"
}
const _hoisted_6 = { class: "navbar-nav flex-grow-1" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-link-text ms-1" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-link-text ms-1" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-link-text ms-1" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-link-text ms-1" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-link-text ms-1" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-link-text ms-1 position-relative" }
const _hoisted_19 = {
  key: 0,
  class: "position-absolute p-2 ms-2 bg-success border border-light rounded-circle"
}
const _hoisted_20 = {
  key: 1,
  class: "position-absolute p-2 ms-2 bg-danger border border-light rounded-circle"
}
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-link-text ms-1" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-link-text ms-1" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "nav-link-text ms-1" }
const _hoisted_29 = { class: "gorda-sidenav__version text-bold text-center" }

import AuthService from '@/services/AuthService'
import {version} from '../../package.json'
import User from '@/models/User'
import WhatsAppClient from "@/services/gordaApi/WhatsAppClient";
import {onMounted, onUnmounted, ref, Ref} from 'vue'
import {ClientObserver} from '@/services/gordaApi/ClientObserver'
import {useStorage} from '@/services/stores/Storage'
import {storeToRefs} from 'pinia'
import {useWpClientsStore} from "@/services/stores/WpClientStore";
import {useSidenavStore} from '@/services/stores/SidenavStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

let user: Ref<User> = ref(new User())
let isAdmin: Ref<boolean> = ref(false)
let isSuperAdmin: Ref<boolean> = ref(false)
let connectionState: Ref<boolean> = ref(false)
let socket: WhatsAppClient
let observer: ClientObserver
const storage = useStorage()
const {photoUrl} = storeToRefs(storage)
const {getDefault} = useWpClientsStore()
const sidenavStore = useSidenavStore()
const {railCollapsed} = storeToRefs(sidenavStore)
const {toggle} = sidenavStore

function signOut(): void {
  AuthService.logOut()
}

const onUpdate = (socket: WhatsAppClient): void => {
  connectionState.value = socket.isConnected()
}

onMounted(async () => {
  user.value = AuthService.getCurrentUser()
  isAdmin.value = user.value.isAdmin()
  isSuperAdmin.value = user.value.isSuperAdmin()
  if (!user.value.photoUrl) {
    await storage.getDefaultPhotoUrl()
  }
  if (getDefault()) {
    socket = WhatsAppClient.getInstance(getDefault())
    observer = new ClientObserver(onUpdate)
    socket.attach(observer)
  }
})

onUnmounted(() => {
  if (socket) socket.detach(observer)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["gorda-sidenav sidenav navbar navbar-vertical bg-light navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3", {'gorda-sidenav--rail': _unref(railCollapsed)}]),
    id: "sidenav-main"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand m-0",
        tag: "a",
        to: {name: 'profile'}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(user).photoUrl || _unref(photoUrl),
            class: "navbar-brand-img d-inline-block align-top border-radius-lg",
            alt: "main_logo"
          }, null, 8, _hoisted_2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(user).name), 1)
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "gorda-sidenav__rail-toggle",
        type: "button",
        title: _unref(railCollapsed) ? _ctx.$t('sidenav.expand') : _ctx.$t('sidenav.collapse'),
        "aria-label": _unref(railCollapsed) ? _ctx.$t('sidenav.expand') : _ctx.$t('sidenav.collapse'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)))
      }, [
        _createElementVNode("em", {
          class: _normalizeClass(_unref(railCollapsed) ? 'fas fa-chevron-right' : 'fas fa-chevron-left')
        }, null, 2)
      ], 8, _hoisted_4)
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "horizontal bg-dark dark mt-0" }, null, -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: { name: 'dashboard'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/main') ? 'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? _ctx.$t('routes.dashboard') : undefined
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fas fa-gauge-high" })
              ], -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('routes.dashboard')), 1)
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _createElementVNode("li", _hoisted_9, [
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'users'},
                tag: "a",
                class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/users/') ? 'nav-link active': 'nav-link'),
                title: _unref(railCollapsed) ? _ctx.$t('routes.users') : undefined
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                    _createElementVNode("em", { class: "fas fa-users" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('routes.users')), 1)
                ]),
                _: 1
              }, 8, ["class", "title"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: { name: 'drivers'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/drivers/') ? 'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? _ctx.$t('routes.drivers') : undefined
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fa-solid fa-car-side" })
              ], -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('routes.drivers')), 1)
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: { name: 'vehicles'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/vehicles/') ? 'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? _ctx.$t('routes.vehicles') : undefined
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fa-solid fa-car" })
              ], -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('routes.vehicles')), 1)
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: { name: 'places'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/places/') ? 'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? _ctx.$t('routes.places') : undefined
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fas fa-location-dot" })
              ], -1)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('routes.places')), 1)
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _createElementVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: { name: 'wpClients'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/wp-clients/') ?
                       'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? (_unref(connectionState) ? _ctx.$t('common.chatBot.connected') : _ctx.$t('common.chatBot.disconnected')) : undefined
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fa-brands fa-whatsapp" })
              ], -1)),
              _createElementVNode("span", _hoisted_18, [
                _createTextVNode(_toDisplayString(_unref(connectionState) ? _ctx.$t('common.chatBot.connected') : _ctx.$t('common.chatBot.disconnected')) + " ", 1),
                (_unref(connectionState))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20))
              ])
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _createElementVNode("li", _hoisted_21, [
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'metrics'},
                tag: "a",
                class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/metrics/') ? 'nav-link active': 'nav-link'),
                title: _unref(railCollapsed) ? _ctx.$t('routes.metrics') : undefined
              }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                    _createElementVNode("em", { class: "fa-solid fa-chart-pie" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('routes.metrics')), 1)
                ]),
                _: 1
              }, 8, ["class", "title"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", _hoisted_23, [
          (_unref(isSuperAdmin))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'billing'},
                tag: "a",
                class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/billing') ? 'nav-link active': 'nav-link'),
                title: _unref(railCollapsed) ? 'Billing' : undefined
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                    _createElementVNode("em", { class: "fa-solid fa-file-invoice-dollar" })
                  ], -1),
                  _createElementVNode("span", { class: "nav-link-text ms-1" }, "Billing", -1)
                ]))]),
                _: 1
              }, 8, ["class", "title"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: { name: 'settings'},
            tag: "a",
            class: _normalizeClass(_ctx.$router.currentRoute.value.path.includes('/dashboard/settings/') ? 'nav-link active': 'nav-link'),
            title: _unref(railCollapsed) ? _ctx.$t('routes.settings') : undefined
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
                _createElementVNode("em", { class: "fa-solid fa-screwdriver-wrench" })
              ], -1)),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('routes.settings')), 1)
            ]),
            _: 1
          }, 8, ["class", "title"])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("li", {
          class: "nav-item flex-grow-1",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("li", _hoisted_26, [
          _createElementVNode("a", {
            class: "nav-link",
            onClick: signOut,
            href: "",
            id: "signOut",
            title: _unref(railCollapsed) ? _ctx.$t('users.logOut') : undefined
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center" }, [
              _createElementVNode("em", { class: "fas fa-sign-out-alt" })
            ], -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('users.logOut')), 1)
          ], 8, _hoisted_27)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, _toDisplayString('version ' + _unref(version)), 1)
    ])
  ], 2))
}
}

})